<template>
  <div class="app-footer">
    <p>© {{ currentYear }} 药品流向返利结算系统 - 杭州唯可趣版权所有</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
.app-footer {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #909399;
}
</style> 